<div class="article-popup" *ngIf="isVisible" @slideInOut (@slideInOut.done)="onAnimationDone($event)">
    <div class="popup-title-container">
        <img src="assets/tree-editor/left_pane/btn_left_pane_closed.svg" alt="Close" class="close-icon"
            (click)="close()" />
        <div class="popup-title-text">{{ "support_popup.lbl_article" | translate }}</div>
    </div>

    <div class="popup-content">
        <iframe *ngIf="articleUrl" [src]="articleUrl" class="article-frame" frameborder="0"></iframe>

        <div class="popup-footer">
            <button class="ft-btn ft-btn-active"
                (click)="openFullPage()">{{"support_popup.lbl_open_in_new_tab"| translate}}</button>
        </div>
    </div>
</div>